// src/utils/api.js

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

/**
 * Realiza una petición fetch incluyendo el Token JWT automáticamente.
 * También maneja errores de sesión (401), permisos (403) y rate limit (429).
 */
export const authFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  // Preparamos los headers
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  // Si hay token, lo inyectamos
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  // --- MANEJO CENTRALIZADO DE ERRORES ---

  if (response.status === 401) {
    // Token vencido o inválido
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login'; // Forzar redirección
    throw new Error('Sesión expirada. Inicia sesión de nuevo.');
  }

  if (response.status === 403) {
    throw new Error('No tienes permisos de Administrador para realizar esta acción.');
  }

  if (response.status === 429) {
    throw new Error('Has realizado demasiadas peticiones. Espera un momento.');
  }

  return response;
};